import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Icon, message } from 'antd';
import API_URL from "../../common/url";
import $ from "../../common/AjaxRequest";
import HourModal from "./HourModal";
import ManualRerunModal from "./ManualRerunModal";
import './style/layout.less';
import { actions } from '../../actions/inProjectActions';

const confirm = Modal.confirm;

class Pin extends React.Component {
    state = {
        show: true,
        showRefresh: false,
        showStatistical: false,
        showManualRerun:true
    }

    componentDidMount() {
        this.displayPin();
        this.showRerecordInvJdeContract()
    }

    componentWillReceiveProps() {
        this.displayPin();
    }

    handleSubmit = () => {
        const options = {
            method: 'POST',
            url: API_URL.home.calculation,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { error, success } = res;
                if (error) {
                    Modal.error({ title: error });
                }
                if (success) {
                    Modal.success({ title: success });
                }
            }
        }
        message.success('已发起刷新该项目统计数据请求');
        $.sendRequest(options);
    }


    showRerecordInvJdeContract = () => {

        const options = {
            method: 'POST',
            url: API_URL.home.showRerecordInvJdeContract,
            data: {  },
            dataType: 'json',
            doneResult: res => {
                const{isshow}=res;
                this.setState({
                    showManualRerun: isshow==1,
                });
            },
        };
        $.sendRequest(options);
    }

    queryTaskStatus = () => {
        const options = {
            method: 'POST',
            url: API_URL.config.testCalculation,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { status } = data || {};
                if (status === 'COMPLETED') {
                    confirm({
                        title: '确定刷新该项目统计数据?',
                        onOk: () => {
                            this.updateTaskStatus();
                        },
                    });
                } else {
                    Modal.warning({ title: '刷新统计任务正在进行中，请稍后再试！' });
                }
            }
        }
        $.sendRequest(options);
    }

    updateTaskStatus = () => {
        const options = {
            method: 'POST',
            url: API_URL.config.changeCalculationStatus,
            data: { status: 'RUNNING' },
            dataType: 'json',
            doneResult: res => {
                this.handleSubmit();
            }
        }
        $.sendRequest(options);
    }

    switchStatistical = () => {
        const { settlementType } = this.props;
        const billingMonth = settlementType === 'BILLING_MONTH';
        confirm({
            title: `确认要将项目数据，切换为“${billingMonth ? '按自然月' : '按工时结算月'}统计”?`,
            content: '涉及统计数据：项目状态；项目月汇总；中心月汇总；津石与竞争公司对比',
            onOk: () => {
                this.props.switchStatistical(billingMonth ? 'NATURAL_MONTH' : 'BILLING_MONTH');
                message.success('数据切换任务成功！');
            },
        });
    }

    displayPin = () => {
        const { invState, curRole, investigationSiteName } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isPM = curRole == 'PM';
        const isCRCM = curRole == 'CRCM';
        const isBO = curRole == 'BO';
        const isBD = curRole == 'BD';
        const isTAL = curRole == 'TAL';
        const isBDO = curRole == 'BDO';
        const isBDM = curRole == 'BDM';
        const isPA = curRole == 'PA';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isCTA = curRole == 'CTA';
        const isBA = curRole == 'BA';
        const isBAL = curRole == 'BAL';
        const isPML = curRole == 'PML';
        const isCSA = curRole == 'CSA';
        const isCSAL = curRole == 'CSAL';
        if (invState == 0) {
            this.setState({
                show: false,
                showRefresh: false,
                showStatistical: false,
            });
        } else {
            if (isCRC || isCRCC || isCRCM || isPML || (investigationSiteName && (isPM || isPA))) {
                this.setState({ show: true });
            } else {
                this.setState({ show: false });
            }
            if ((investigationSiteName && (isPM || isPA || isCTA)) || isVP || isFIN || isBO || isBD || isBDO || isTAL || isBDM || isBA || isBAL || isCSA || isCSAL || isPML ) {
                this.setState({ showRefresh: true });
            } else {
                this.setState({ showRefresh: false });
            }
            if (investigationSiteName) {
                this.setState({ showStatistical: true });
            } else {
                this.setState({ showStatistical: false });
            }
        }
    }

    showHourModal = () => {
        this.hourModalRef.show();
    }

    showManualRerunModal = () => {
        this.manualRerunModalRef.show();
    }

    render() {
        const { show, showRefresh, showStatistical, showManualRerun } = this.state;
        const hash = location.hash.substr(1);
        const urlRight = hash === "/financeManagement/financeIncomeReport";
        return (
            <div className="pin-right">
                {show && <div className="pin pin-hour" onClick={this.showHourModal}><i className="icon iconfont">&#xe64f;</i>填写工时</div>}
                {showRefresh && <div className="pin pin-refresh" onClick={this.queryTaskStatus}><Icon type="sync" />刷新统计</div>}
                {showStatistical && <div className="pin pin-statistical" onClick={this.switchStatistical}><Icon type="swap" style={{ border: '1px solid #FFF', borderRadius: '50%' }} />数据切换</div>}
                <HourModal ref={el => this.hourModalRef = el} />
                <ManualRerunModal ref={el => this.manualRerunModalRef = el} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Pin);



// WEBPACK FOOTER //
// ./src/components/layout/Pin.js